import { ThirdPartySsoState } from '@pages/third-party-sso-authentication/store/state/third-party-sso.state';

export const thirdPartySsoState = [ThirdPartySsoState];
